import { css } from "styled-components";

export const inputBox = css<{ $bgColor?: string }>`
  background: ${(p) => p.$bgColor || p.theme.colors.cardBgColor};
  color: ${(p) => p.theme.colors.primaryGrey};
  border: 1px solid ${(p) => p.theme.colors.lightBorderGrey};
  border-radius: 6px;
`;
